import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LegalHero from './components/LegalHero';
import PrivacyContent from './components/PrivacyContent';
import LegalContent from './components/LegalContent';
import LegalContactForm from './components/LegalContactForm';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

type Tab = 'privacidad' | 'legal';

export default function LegalPage() {
  const [activeTab, setActiveTab] = useState<Tab>('privacidad');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const heroData = {
    privacidad: {
      title: 'Política de Privacidad',
      subtitle: 'Tu privacidad es importante para nosotros. Aquí te explicamos cómo tratamos tus datos personales.',
    },
    legal: {
      title: 'Aviso Legal',
      subtitle: 'Información legal sobre el uso de este sitio web y las condiciones de nuestros servicios.',
    },
  };

  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      <LegalHero title={heroData[activeTab].title} subtitle={heroData[activeTab].subtitle} />

      <section className="px-4 md:px-8 py-12 md:py-16">
        <div className="max-w-4xl mx-auto mb-10">
          <div className="flex items-center gap-1 bg-neutral-100 rounded-full p-1 w-fit mx-auto">
            <button
              onClick={() => setActiveTab('privacidad')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'privacidad'
                  ? 'bg-neutral-900 text-white shadow-sm'
                  : 'text-neutral-600 hover:text-neutral-900'
              }`}
            >
              <i className="ri-shield-check-line mr-2"></i>
              Política de Privacidad
            </button>
            <button
              onClick={() => setActiveTab('legal')}
              className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeTab === 'legal'
                  ? 'bg-neutral-900 text-white shadow-sm'
                  : 'text-neutral-600 hover:text-neutral-900'
              }`}
            >
              <i className="ri-file-shield-2-line mr-2"></i>
              Aviso Legal
            </button>
          </div>
        </div>

        {activeTab === 'privacidad' ? <PrivacyContent /> : <LegalContent />}

        <LegalContactForm />
      </section>

      <Footer />
      <WhatsAppButton />
    </main>
  );
}
